import React from 'react'
import styles from './styles.module.scss'
import htmr from 'htmr'

type FlashBannerMessageProps = {
  messageDesktop: string
  messageMobile: string
}

function FlashBannerMessage({
  messageDesktop,
  messageMobile
}: FlashBannerMessageProps) {
  return (
    <div className={styles.flashMsg}>
      <p className={styles.flashMsg__desktop}>{htmr(messageDesktop)}</p>
      <p className={styles.flashMsg__mobile}>{htmr(messageMobile)}</p>
    </div>
  )
}

export default FlashBannerMessage
